import React, { useEffect, useState } from "react";
import "../styles/Blog.scss";
import PageTop from "../comps/PageTop";
import blog_img from "../assets/gallery/g-top.jpg";
import Blog_comp from "../comps/Blog_comp";
import Blog_Recent_post from "../comps/Blog_Recent_post";
import Pagebreak from "../comps/Pagebreak";
import axios from "axios";
import { FiSearch } from "react-icons/fi";
function Blog(props) {
  const [blogs, setBlogs] = useState([]);
  const [value, setValue] = useState(4);
  const fetchBlogs = async () => {
    try {
      props.setLoader(true);
      const response = await axios.get(
        `${process.env.REACT_APP_URL}blog/getallblogs`
      );

      setBlogs(response.data.map((item) => item.data));
      setFilteredBlogs(response.data.map((item) => item.data));
    } catch (error) {
      console.log(error);
    } finally {
      props.setLoader(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const [toggle, settoggle] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredBlogs, setFilteredBlogs] = useState(blogs);
  const searchHandler = () => {
    settoggle(true);
    if (!search.trim()) {
      setFilteredBlogs(blogs);
      return;
    }
    const filtered = blogs.filter((item) => {
      return (
        (item.title &&
          item.title.toLowerCase().includes(search.toLowerCase())) ||
        (item.description &&
          item.description.toLowerCase().includes(search.toLowerCase()))
      );
    });
    setFilteredBlogs(filtered);
  };
  const closeHandler = () => {
    settoggle(false);
    setFilteredBlogs(blogs);
    setSearch("");
  };
  return (
    <>
      <PageTop img={blog_img} title="Archives" />
      <Pagebreak greyBreakPage={true} />
      <div className="blog-parent parent">
        <div className="blog-search-box-container cont">
          <div className="blog-search-box">
            <input
              type="text"
              className="blogs-search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search Blogs..."
            />
            {!toggle ? (
              <button
                className="search-btn"
                onClick={() => searchHandler()}
                disabled={search == ""}
              >
                <FiSearch />
              </button>
            ) : (
              <button className="search-btn" onClick={() => closeHandler()}>
                X
              </button>
            )}
          </div>
        </div>
        <div className="blog-container cont">
          <div className="blog-left">
            <div className="blogs-box">
              {filteredBlogs.length > 0
                ? [...filteredBlogs]
                    .reverse()
                    .slice(0, value)
                    .map((data, index) => {
                      return (
                        <Blog_comp
                          image={data.featuredImage}
                          title={data.title}
                          para={data.description}
                          date={data.date}
                          category={data.category}
                          link={data.bid}
                        />
                      );
                    })
                : "No Blogs Found"}
            </div>

            {value <= filteredBlogs.length && (
              <button
                onClick={() => setValue(value + 4)}
                className="btn loadmore-btn load-more"
              >
                show more
              </button>
            )}
          </div>

          <div className="blog-right">
            <div className="text-recent">RECENT POST</div>

            {blogs &&
              [...blogs]
                .reverse()
                .slice(0, 4)
                .map((data, index) => {
                  return (
                    <Blog_Recent_post
                      title={data.title}
                      date={data.date}
                      comments={data.category}
                      image={data.featuredImage}
                      link={data.id}
                    />
                  );
                })}
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog;
